module.exports = "/_next/static/images/5950eb6a55756f21ab3c9551742d3603-aboutus-hiring.jpg.webp";